<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <dff-side-titel>{{ vm.indstillinger.menuTekst }}</dff-side-titel>
    <dff-side-tekst [titel]="vm.indstillinger.titel" [tekst]="vm.indstillinger.beskrivelse"></dff-side-tekst>
    @if (vm.indstillinger.forbrug.synlig) {
      <forbrugsnotifikation-sektion
        [formGroup]="vm.formGroup.get('forbrug')"
        [indstillinger]="vm.indstillinger.forbrug"
        [min]="-25"
        [max]="50"
        suffix="%"
      ></forbrugsnotifikation-sektion>
    }
    @if (vm.indstillinger.retur.synlig) {
      <forbrugsnotifikation-sektion
        [formGroup]="vm.formGroup.get('retur')"
        [indstillinger]="vm.indstillinger.retur"
        [min]="-10"
        [max]="20"
        suffix="°"
      ></forbrugsnotifikation-sektion>
    }
    <forbrugsnotifikation-udsendelse
      [formGroup]="vm.formGroup.get('udsendelse')"
      [indstillinger]="vm.indstillinger.udsendelse"
    ></forbrugsnotifikation-udsendelse>
    <div class="button-panel">
      @if (vm.erTilmeldt) {
        @if (!afmelder) {
          <button
            mat-button
            color="primary"
            [disabled]="afmelder || gemmer"
            role="button"
            type="button"
            [attr.aria-disabled]="afmelder || gemmer"
            (click)="onAfmeldClick(vm)"
            >
            Afmeld
          </button>
        }
        @if (afmelder) {
          <button mat-flat-button color="primary" disabled role="button" type="button" aria-disabled="true">
            <mat-spinner class="mat-spinner" color="basic" diameter="25"></mat-spinner>
            <span>Afmeld</span>
          </button>
        }
      }
      @if (!vm.erTilmeldt) {
        @if (!gemmer) {
          <button
            mat-flat-button
            color="primary"
            [disabled]="afmelder || gemmer || vm.formGroup.invalid"
            [attr.aria-disabled]="afmelder || gemmer || vm.formGroup.invalid"
            (click)="onTilmeldClick(vm)"
            >
            Tilmeld
          </button>
        }
        @if (gemmer) {
          <button mat-flat-button color="primary" disabled role="button" type="button" aria-disabled="true">
            <mat-spinner class="mat-spinner" color="basic" diameter="25"></mat-spinner>
            <span>Tilmeld</span>
          </button>
        }
      }
      @if (vm.erTilmeldt) {
        @if (!gemmer) {
          <button
            mat-flat-button
            color="primary"
            [disabled]="afmelder || gemmer || vm.formGroup.invalid"
            [attr.aria-disabled]="afmelder || gemmer || vm.formGroup.invalid"
            (click)="onGemClick(vm)"
            >
            Gem
          </button>
        }
        @if (gemmer) {
          <button mat-flat-button color="primary" disabled role="button" type="button" aria-disabled="true">
            <mat-spinner class="mat-spinner" color="basic" diameter="25"></mat-spinner>
            <span>Gem</span>
          </button>
        }
      }
    </div>
  }
</dff-side>
